import { Box, BoxProps } from "@mui/material";
import LogoColorNormal from "./logo-color-normal.svg?react";
import LogoMonoNormal from "./logo-mono-normal.svg?react";

export function LogoInsight({ dark, ...props }: Omit<BoxProps, "children"> & { dark?: boolean }) {
  return (
    <Box overflow="hidden" {...props}>
      {dark ? (
        <LogoMonoNormal width="100%" height="100%" />
      ) : (
        <LogoColorNormal width="100%" height="100%" />
      )}
    </Box>
  );
}
